// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"5e8459f7","582":"5e8459f7","818":"5e8459f7","827":"5e8459f7"}[chunkId] + ".chunk.css";
};